import * as React from 'react'

const CircledCloseIcon = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={14} cy={14} r={13.5} stroke="#404040" />
    <path
      d="M7.63623 7.63636L20.3635 20.3636"
      stroke="#404040"
      strokeLinecap="round"
    />
    <path
      d="M20.3638 7.63636L7.6365 20.3636"
      stroke="#404040"
      strokeLinecap="round"
    />
  </svg>
)

export default CircledCloseIcon
